import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useHelpStore = defineStore('help', () => {
  const isOpen = ref(false)
  const currentSlug = ref<string | null>(null)

  function open(slug: string) {
    currentSlug.value = slug
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  return { isOpen, currentSlug, open, close }
})
